import React from 'react';

import { getQuestTiers, isTieredChallenge } from '../../loyalty-quest/utils';

import { RegularSteps } from './regular-steps';
import { TieredSteps } from './tiered-steps/tiered-steps';
import { IQuestStepsProps } from './types';

export const QuestSteps = ({
  cmsQuestRequirementById,
  cmsQuestDetail,
  cmsQuestDetailUI,
  quest,
  onCloseDrawer,
}: IQuestStepsProps) => {
  const cmsSteps = cmsQuestDetail?.questRules?.steps || [];

  if (!quest || !quest?.steps) {
    return null;
  }

  const tiers = getQuestTiers(quest);
  const shouldRenderTieredSteps = isTieredChallenge({ quest, tiers });

  const commonProps = {
    quest,
    cmsSteps,
    cmsQuestRequirementById,
    cmsQuestDetailUI,
    onCloseDrawer,
  };

  return shouldRenderTieredSteps ? (
    <TieredSteps tiers={tiers} {...commonProps} />
  ) : (
    <RegularSteps {...commonProps} />
  );
};
